import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function MinimalEducation(t0) {
  const $ = _c(14);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "basic":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("minimalEducation.basic");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "secondaryWithApprenticeshipCertificate":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("minimalEducation.secondaryWithApprenticeshipCertificate");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "secondaryWithSchoolLeavingExamination":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("minimalEducation.secondaryWithSchoolLeavingExamination");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "higherVocational":
      {
        let t1;
        if ($[6] !== t) {
          t1 = t("minimalEducation.higherVocational");
          $[6] = t;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "bachelorDegree":
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("minimalEducation.bachelorDegree");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case "masterDegree":
      {
        let t1;
        if ($[10] !== t) {
          t1 = t("minimalEducation.masterDegree");
          $[10] = t;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case "doctoralDegree":
      {
        let t1;
        if ($[12] !== t) {
          t1 = t("minimalEducation.doctoralDegree");
          $[12] = t;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}